<template>

    <div>
        <ul>
              <li v-for="user in users">
                <strong>
                    {{user.id}} {{user.created_at}} /
                    {{ user.name }} / {{ user.email }}
                    </strong>
                <span class="btn btn-sm btn-outline-primary" @click="login(user)">login</span>
              </li>
        </ul>


    </div>

</template>
<script>

import componentFunctions from '@/mixin.components.js'
import axios from 'axios';
import Vue from 'vue';

export default window.vmPage = {
  mixins:[componentFunctions],
  data() {
    return {
        users:[]
    }
  },
  mounted(){
    this.getUsers();

  },
  methods:{
      login(user){
        axios({
            method: 'post',
            url: '/api/loginWith/'+user.id,
        }).then(()=>{
            toastr('ok');
            //this.$router.replace('/');
            window.location = '/';
        }).catch(res=>{
            toastr('falha','','red');
            console.error(res);
        });

      },


    getUsers(){
      axios({
        url: '/api/users',
      }).then((res) => {
        this.users = res.data;
      });

    },


  }

}


</script>

